<template>
  <div class="left-menu">
   <el-menu
      :default-active="active"
      @select="onSelect">
      <span v-for="(item,index) in list" :key="index">
          <template v-if="item.children && item.children.length && (item.permission === undefined || item.permission === true)">
            <el-submenu :index="item.name">
              <template slot="title">
                <i :class="item.meta.icon"></i>
                <span>{{item.meta.title}}</span>
              </template>
              <span v-for="(son,sonIndex) in item.children" :key="sonIndex">
                  <template v-if="son.meta.show && (son.permission === undefined || son.permission === true)">
                     <el-menu-item :index="son.name">{{son.meta.title}}</el-menu-item>
                  </template>
              </span>
            </el-submenu>
          </template>
          <!-- <template v-else>
             <el-menu-item :index="item.name">
              <i class="el-icon-menu"></i>
              <span slot="title">{{item.meta.title}}</span>
            </el-menu-item>
          </template> -->
      </span>
   </el-menu>
  </div>
</template>

<script>
export default {
  name: 'leftMenu',
  props:{
    list:{
      type:Array,
      default:()=>{
        return []
      }
    },
    active:{
      type:String,
      default:''
    }
  },
  data () {
    return {
      defaultActive:""
    }
  },
  created(){
      this.defaultActive = this.active
      const firstMenu = this.$menuLimit.filter(x => x.includes('first')) // 一级菜单权限
      const secondMenu = this.$menuLimit.filter(x => x.includes('second')) // 二级菜单权限
      //添加了二级菜单权限的模块
      const firSecMap = {
        'audit': {
          'audit-my': 'check_menu_second',
          'audit-start': 'auditstart_menu_second',
          'audit-list': 'auditlist_menu_second'
        },
        'account': {
          'account-permission': 'accpermission_menu_second',
        },
        'customer':{
          'customer-dealer':'dealer_menu_second',
        },
        'property':{
          'property-car-type-manage':'car_type_menu_second',
        }
      }
      // 添加一级菜单权限的模块
      const firstMap = {
        'customer':'customer_menu_first', // 客户管理
        'property':'property_menu_first', // 资产管理
        'delivery':'delivery_menu_first', //交付管理
        'audit':'audit_menu_first', // 审批中心
        'workorder':'workorder_menu_first', // 服务管理
        'carDrive':'carDrive_menu_first', // 智驾系统管理
        'account':'account_menu_first' // 账号管理
      }      
      for (const first of this.list) {
        let children = first.children
        if (Object.keys(firSecMap).includes(first.name)) {
          let map = firSecMap[first.name]
          for (const key in map) {
            let sec = children.find(x => x.name == key)
            sec.permission = false
            if (secondMenu.includes(map[key])) {
              sec.permission = true
            }
          }
        }
        if ( Object.keys(firstMap).includes(first.name)) {
          first.permission = false
          if (firstMenu.includes(firstMap[first.name])) {
            first.permission = true
          }
        }
      }
  },
  methods:{
    onSelect(index){
      this.defaultActive = index
      let path = '/'+index.replace("-","/")
      this.$router.push({ path})
    }
  }
}
</script>

<style scoped>
.left-menu{
  width: 204px;
  height: calc(100vh - 56px);
  background-color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/left-menu/index.vue